module.exports = __webpack_public_path__ + "assets/img/1c12-ie.svg";